import React, { useEffect } from "react";
import { Button, Card, Col, Layout, PageHeader, Row, Space, Spin, Table } from "antd";
import { EditOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";
import { RegionDlg } from "./RegionDlg";
import { Toolbar } from "../../../components/Toolbar";
import { timezones } from "../../../common/Utils";
import { DivisionDlg } from "./DivisionDlg";
import { useRegions } from "../../../hooks/regions/useRegions";
import { useEditRegion } from "../../../hooks/regions/useEditRegion";
import { useEditDivision } from "../../../hooks/regions/useEditDivision";
import { useEmployees } from "../../../hooks/system/useEmployees";

export const Regions = () => {
  const { refresh: refreshEmployees, regionDirectors, divisionDirectors } = useEmployees();
  const { refresh, regions, divisions, loading } = useRegions();
  const { edit: editRegion, ...regionEdit } = useEditRegion({refresh});
  const { edit: editDivision, ...divisionEdit } = useEditDivision({refresh});

  useEffect(() => {
    refresh();
    refreshEmployees();
  }, []);

  const columns = [
    {
      title: "Division Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Division Director",
      key: "director",
      render: (_, r) => (
        <Space>
          {r.directors.map((x) => (
            <span>
              <UserOutlined /> {x.name}
            </span>
          ))}
        </Space>
      ),
    },
    {
      title: "Time Zone",
      dataIndex: "zoneId",
      key: "zoneId",
      sorter: (a, b) =>
        (timezones.find((t) => t.key === a.zoneId)?.val || "").localeCompare(
          timezones.find((t) => t.key === b.zoneId)?.val || ""
        ),
      render: (x) => timezones.find((t) => t.key === x)?.val,
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => <EditOutlined onClick={() => editDivision(r)} />,
    },
  ];

  const findDivisions = (regionId) => divisions.filter((x) => x.regionId === regionId);

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          <Button type="primary" size="large" icon={<PlusOutlined />} onClick={() => editRegion({})}>
            New Region
          </Button>
        }
      ></Toolbar>

      {loading ? (
        <div style={{ height: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Spin size="large"></Spin>
        </div>
      ) : (
        <div>
          <Row gutter={16}>
            {regions.map((x: any) => (
              <Col key={x.id} span={12} style={{ marginTop: 16 }}>
                <Card bodyStyle={{ padding: 0 }} hoverable>
                  <PageHeader
                    title={x.name}
                    extra={[
                      <Button icon={<EditOutlined />} onClick={() => editRegion(x)}>
                        Edit Region
                      </Button>,
                      <Button type="primary" icon={<PlusOutlined />} onClick={() => editDivision({})}>
                        Add Division
                      </Button>,
                    ]}
                  >
                    <div>
                      <Space>
                        {x.directors?.map((d) => (
                          <span key={d.id}>
                            <UserOutlined /> {d.name}
                          </span>
                        ))}
                      </Space>
                    </div>

                    <Table
                      size="small"
                      rowKey="id"
                      columns={columns}
                      dataSource={findDivisions(x.id)}
                      style={{ marginTop: 16 }}
                      pagination={false}
                    />
                  </PageHeader>
                </Card>
              </Col>
            ))}
          </Row>
          <RegionDlg regionDirectors={regionDirectors} {...regionEdit} />
          <DivisionDlg divisionDirectors={divisionDirectors} regions={regions} {...divisionEdit} />
        </div>
      )}
    </Layout.Content>
  );
};
